import React, { useEffect } from "react";
import { useFormik } from "formik";
import { FaUserEdit } from "react-icons/fa";
import { AiOutlineTransaction } from "react-icons/ai";
import * as Yup from "yup";
import ButtonComponent from "../../components/Button";
import InputComponent from "../../components/Input";
import { useDispatch } from "react-redux";
import { PlaceOrder } from "../../store/actions/user-action";

const PlaceManualOrder = () => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      userId: "",
      merchantTransactionId: "",
    },
    validationSchema: Yup.object({
      userId: Yup.string().required("User Id is required"),
      merchantTransactionId: Yup.string().required("Transaction Id is required"),
    }),
    onSubmit: async ({ userId, merchantTransactionId }, formik) => {
      const payload = {
        userId,
        merchantTransactionId,
      };
      dispatch(PlaceOrder(payload, formik));
    },
  });

  useEffect(() => {}, [formik.values]);

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium">Place Manual Order</h3>
      <p className="text-sm text-[#595858] mt-2">
        Place manual order , Lorem ipsum is a placeholder text commonly used to
        demonstrate the visual form of a document or a typeface without relying
        on meaningful content.
      </p>

      {/* Form starts here */}
      <form className="mt-5 w-[90%] m-auto" onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 gap-4">
          <div className=" mb-4">
            <label
              htmlFor="quantity"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              User Id
            </label>
            <InputComponent
              icon={<FaUserEdit />}
              type="text"
              name="userId"
              value={formik.values.userId} // Controlled input
              placeholder="Enter your User Id"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.userId && formik.errors.userId && (
              <p className="text-red-500 text-sm">{formik.errors.userId}</p>
            )}
          </div>
          <div className=" mb-4">
            <label
              htmlFor="quantity"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Transaction Id
            </label>
            <InputComponent
              icon={<AiOutlineTransaction />}
              type="text"
              name="merchantTransactionId"
              value={formik.values.merchantTransactionId} // Controlled input
              placeholder="Enter your Transaction Id"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.merchantTransactionId && formik.errors.merchantTransactionId && (
              <p className="text-red-500 text-sm">
                {formik.errors.merchantTransactionId}
              </p>
            )}
          </div>
        </div>

        <div className="mt-5 text-right rounded">
          <ButtonComponent text="Place Order" type="submit" />
        </div>
      </form>
    </div>
  );
};

export default PlaceManualOrder;
